export enum NavigationMenuFooterItemId {
  AddOns = 'addOns',
  Feedback = 'feedback',
  Help = 'help',
}
